import { ref } from 'vue';
import axios from 'axios';
import { searchContactsByName } from '@/modules/contact/infrastructure/api/contactApi';
import { logger } from '@/infrastructure/services/LoggerService';
export function useContactSearch() {
    const suggestions = ref([]);
    const isLoading = ref(false);
    const isError = ref(false);
    let abortController = null;
    let requestId = 0;
    async function search(query) {
        abortController?.abort();
        if (!query.trim()) {
            suggestions.value = [];
            isLoading.value = false;
            isError.value = false;
            return;
        }
        abortController = new AbortController();
        const currentId = ++requestId;
        isLoading.value = true;
        isError.value = false;
        try {
            const response = await searchContactsByName(query.trim(), 20, abortController.signal);
            if (currentId !== requestId)
                return;
            suggestions.value = response.data.map((c) => ({
                value: c.id,
                label: `${c.firstName} ${c.lastName}`.trim() || c.id,
                image: c.avatarUrl ?? null,
            }));
        }
        catch (err) {
            if (axios.isCancel(err))
                return;
            logger.error('Contact search failed', err);
            suggestions.value = [];
            isError.value = true;
        }
        finally {
            if (currentId === requestId)
                isLoading.value = false;
        }
    }
    function clear() {
        abortController?.abort();
        suggestions.value = [];
        isError.value = false;
    }
    return { suggestions, isLoading, isError, search, clear };
}
